import { CustomTooltip } from "@shared/components/CustomTooltip";
import { Card, CardContent, CardHeader, CardTitle } from "@shared/ui/card";
import { Activity } from "lucide-react";
import React from "react";

interface KeyStatsCardProps {
  data: {
    consumerCount: number;
    premiseCount: number;
    runCount: number;
    coverage: number;
  };
}

export const KeyStatsCard: React.FC<KeyStatsCardProps> = ({ data }) => {
  return (
    <Card>
      <CardHeader className="pb-3">
        <div className="flex items-center gap-2">
          <Activity className="h-5 w-5 text-green-600" />
          <CardTitle className="text-lg font-semibold">Cycle Overview</CardTitle>
        </div>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="text-sm text-gray-600">Consumer Count</span>
            {/* <CustomTooltip message="Total meters included in this cycle scope." /> */}
          </div>
          <span>{data?.consumerCount ?? "NA"}</span>
        </div>

        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="text-sm text-gray-600">Premise Count</span>
            {/* <CustomTooltip message="Number of readings submitted so far in this cycle." /> */}
          </div>
          <div className="text-right">
            <span>
              {data?.premiseCount ?? "0"}
            </span>
          </div>
        </div>

        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="text-sm text-gray-600">Run Count</span>
            {/* <CustomTooltip message="Count of readings not captured yet. Use estimation if needed." /> */}
          </div>
          <div className="text-right">
            <span>
              {data?.runCount ?? 0}
            </span>
          </div>
        </div>

        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="text-sm text-gray-600">Coverage</span>
            {/* <CustomTooltip message="Routes assigned to readers vs total routes in this cycle." /> */}
          </div>
          <span className="">
            {`${data?.coverage ?? 0}%`}
          </span>
        </div>
      </CardContent>
    </Card>
  );
};
